import getEnvironment from "./getEnvironment";
import addLog from "./addLog";

const getApiUrl = (url: string, isToUseAuthZero: boolean = false): string => {
  let requestUrl;
  const previewOrProd = ["preview", "production"].includes(getEnvironment());

  try {
    const urlObject = new URL(url);
    if (isToUseAuthZero) {
      requestUrl = new URL(
        `${urlObject.pathname}${urlObject.search}`,
        process.env.apiFunctionUrl || urlObject.origin
      ).toString();
    } else {
      requestUrl = new URL(
        `${previewOrProd ? "lot" : ""}${urlObject.pathname}${urlObject.search}`,
        process.env.apiFunctionUrl || urlObject.origin
      ).toString();
    }
    addLog({
      severity: "info",
      message: `DBG requestUrl - ${requestUrl}`,
    });
  } catch (err) {
    throw err;
  }
  return requestUrl;
};

export default getApiUrl;
